import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d964eb90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "dialog-inner" }
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, " How would you like to connect the node " + _toDisplayString(_ctx.nodeName) + " to the topic " + _toDisplayString(_ctx.topicName) + "? ", 1),
          (!_ctx.node?.subscribers.includes(_ctx.topic?.id || ''))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "rectangle-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addSubscriber()))
              }, " Add Subscriber "))
            : _createCommentVNode("", true),
          (_ctx.node?.subscribers.includes(_ctx.topic?.id || ''))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "rectangle-button red",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeSubscriber()))
              }, " Remove Subscriber "))
            : _createCommentVNode("", true),
          (!_ctx.node?.publishers.includes(_ctx.topic?.id || ''))
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "rectangle-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addPublisher()))
              }, " Add Publisher "))
            : _createCommentVNode("", true),
          (_ctx.node?.publishers.includes(_ctx.topic?.id || ''))
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "rectangle-button red",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removePublisher()))
              }, " Remove Publisher "))
            : _createCommentVNode("", true),
          (
          !_ctx.node?.publishers.includes(_ctx.topic?.id || '') ||
          !_ctx.node?.subscribers.includes(_ctx.topic?.id || '')
        )
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                class: "rectangle-button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addBoth())),
                disabled: 
          _ctx.node?.publishers.includes(_ctx.topic?.id || '') ||
          _ctx.node?.subscribers.includes(_ctx.topic?.id || '')
        
              }, " Add Both ", 8, _hoisted_3))
            : _createCommentVNode("", true),
          (
          _ctx.node?.publishers.includes(_ctx.topic?.id || '') &&
          _ctx.node?.subscribers.includes(_ctx.topic?.id || '')
        )
            ? (_openBlock(), _createElementBlock("button", {
                key: 5,
                class: "rectangle-button red",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeBoth()))
              }, " Remove Both "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "rectangle-button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exit()))
          }, "Done")
        ]),
        _createElementVNode("div", {
          class: "dialog-bg",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exit()))
        })
      ]))
    : _createCommentVNode("", true)
}